import getUserLocale from "./getUserLocale"

const formatWithPrefixAndSuffix = (dimension: string | number, prefix = "", suffix = "") =>
	`${prefix}${dimension}${suffix}`

export const getLocalizedDimensions = (
	width: number,
	height: number,
	depth: number,
	locale?: string,
) => {
	try {
		const userLocale = getUserLocale(locale)
		const numberFormat = new Intl.NumberFormat(userLocale)

		const localizedWidth = width ? numberFormat.format(width) : null
		const localizedHeight = height ? numberFormat.format(height) : null
		const localizedDepth = depth ? numberFormat.format(depth) : null

		return { localizedWidth, localizedHeight, localizedDepth }
	} catch (err) {
		console.error(err)
		return {
			localizedWidth: width ? width.toLocaleString() : null,
			localizedHeight: height ? height.toLocaleString() : null,
			localizedDepth: depth ? depth.toLocaleString() : null,
		}
	}
}

const formatDimensions = (
	width: number,
	height: number,
	depth: number,
	options: {
		locale?: string
		prefix?: string
		suffix?: string
	} = {},
) => {
	const { localizedWidth, localizedHeight, localizedDepth } = getLocalizedDimensions(
		width,
		height,
		depth,
	)

	const { prefix, suffix } = options

	const formattedWidth = formatWithPrefixAndSuffix(localizedWidth, prefix, suffix)
	const formattedHeight = formatWithPrefixAndSuffix(localizedHeight, prefix, suffix)
	const formattedDepth = formatWithPrefixAndSuffix(localizedDepth, prefix, suffix)

	const formattedDimensions = []
	if (formattedWidth) formattedDimensions.push(formattedWidth)
	if (formattedHeight) formattedDimensions.push(formattedHeight)
	if (formattedDepth) formattedDimensions.push(formattedDepth)

	return formattedDimensions.join(" x ")
}

export default formatDimensions
